export const REFERRAL_INVITE_SESSION_KEY = 'referral-invite-checked';

/**
 * Uma checagem do convite por aba. Memória e `sessionStorage` porque o storage pode lançar; o id porque
 * logout não limpa nenhum dos dois.
 */
let checkedOwner: number | null = null;

const hasStoredCheck = (userId: number): boolean => {
  try {
    const stored = JSON.parse(
      sessionStorage.getItem(REFERRAL_INVITE_SESSION_KEY) ?? 'null',
    );

    return stored?.userId === userId;
  } catch {
    return false;
  }
};

export const hasCheckedReferralInvite = (userId: number): boolean =>
  checkedOwner === userId || hasStoredCheck(userId);

export const markReferralInviteChecked = (userId: number) => {
  checkedOwner = userId;

  try {
    sessionStorage.setItem(
      REFERRAL_INVITE_SESSION_KEY,
      JSON.stringify({ userId }),
    );
  } catch {
    // Sem storage, a memória ainda cobre a remontagem.
  }
};

export const clearReferralInviteCheck = (userId: number) => {
  if (checkedOwner === userId) checkedOwner = null;

  try {
    if (hasStoredCheck(userId))
      sessionStorage.removeItem(REFERRAL_INVITE_SESSION_KEY);
  } catch {
    // Sem storage, só a memória foi marcada.
  }
};
